import Component from 'vue-class-component';
import { SECTION_TYPES} from '@/content/values/sections';
import EdVideoViewer from '@/content/pages/course-viewer/components/ed-video-viewer/ed-video-viewer.vue';
import EdLinkViewer from '@/content/pages/course-viewer/components/ed-link-viewer/ed-link-viewer.vue';
import EdTextViewer from '@/content/pages/course-viewer/components/ed-text-viewer/ed-text-viewer.vue';
import EdImagesViewer from '@/content/pages/course-viewer/components/ed-images-viewer/ed-images-viewer.vue';
import EdSubdeckViewer from '@/courses/components/flash-cards/ed-subdeck-viewer/ed-subdeck-viewer.component.vue';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';
import EdMaterialViewer from '@/courses/components/ed-material-viewer/ed-material-viewer.vue';
import EdOtherFilesViewer from '@/content/pages/course-viewer/components/ed-other-files-viewer/ed-other-files-viewer.vue';
import EdHtmlViewer from '@/components/common/ed-html-viewer/ed-html-viewer.vue';
import { IparamsComponentSelected } from '@/courses/interfaces/params-component-selected'
import { FOOTER_TYPE } from '@/core/values/core.values';
import { COMPONENT_TYPE } from '@/courses/values/courses.values'
import Content from '../../../../models/content.model';
import { Section } from '@/courses/models/section.model';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { Mixins , Prop , Watch } from 'vue-property-decorator';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import Course from '@/content/models/course.model';
import EdPresentationModeTask from '@/content/components/ed-presentation-mode/ed-presentation-mode-task/ed-presentation-mode-task.component.vue'
import { VIEWER_PRESENTATION_TASK } from '@/content/values/ed-presentation-mode.values';
import EdScanImagesViewer from '@/content/pages/course-viewer/components/ed-scan-images-viewer/ed-scan-images-viewer.component.vue';

@Component({
  name: 'ed-object-preview',
  components: {
    EdVideoViewer,
    EdLinkViewer,
    EdTextViewer,
    EdImagesViewer,
    EdFileViewer,
    EdSubdeckViewer,
    EdMaterialViewer,
    EdOtherFilesViewer,
    EdPresentationModeTask,
    EdHtmlViewer,
    EdScanImagesViewer,
  }
})
export default class EdObjectPreview extends Mixins(CourseToolsMixin) {

  @Prop() readonly courseId: number;
  @Prop({default: null}) readonly classId: number;
  private id = new Date().getTime();
  private lastActiveViewer: any = null;
  private isActive = true;

  get viewerId() {
    if(!this.isPresentationModeTeacher){
      this.id = new Date().getTime();
    }

    if(this.sectionSelected && this.isWhiteboardTransparency && this.isBoardSectionHomework && this.validatePresentationTaskUser){
      return `${this.sectionSelected.sectionId}${this.id}${this.currentBoardUserId}`;
    } else if(this.sectionSelected) {
      return `${this.sectionSelected.sectionId}${this.id}`;
    } else if(this.materialSelected) {
      return `${this.materialSelected.relatedContentId}${this.id}`;
    } else if(this.projectSelected) {
      return `${this.projectSelected.projectId}${this.id}`;
    } else {
      return this.id;
    }
  }

  get sectionSelected(): Section {
    return this.course.viewer.sectionSelected;
  }

  get materialSelected(): any {
    return this.course.viewer.materialSelected;
  }

  get projectSelected(): any {
    return this.course.viewer.projectSelected;
  }

  get sectionLoaded(): Section {
    if(this.sectionSelected) {
      return this.sectionSelected;
    } else if (this.materialSelected) {
      let materialSelected = this.course.viewer.materialSelected;
      return materialSelected ? this.getSectionMaterial(materialSelected.data) : null;
    } else {
      return this.projectSelected.section;
    }
  }

  get viewerLoad(): any {
    let viewer = null;
    if (this.sectionSelected && this.isWhiteboardTransparency && this.isBoardSectionHomework
        && this.validatePresentationTaskUser && this.courseId == this.presentationCourseSelected) {
      viewer = VIEWER_PRESENTATION_TASK;
    } else if (this.sectionLoaded.sectionMaterial?.materialAssetInfo) {
      viewer = this.setCourseMaterialViewer(this.sectionLoaded.sectionMaterial);
    } else if (this.sectionSelected || this.projectSelected) {
      viewer = SECTION_TYPES[this.sectionLoaded.type].viewer;
    } else {
      viewer = this.setCourseMaterialViewer(this.sectionMaterialLoaded);
    }

    // If component is not active and viewer changed, return null to prevent mounting
    if (!this.isActive && this.lastActiveViewer !== viewer) {
      return null;
    }

    // Update lastActiveViewer when component is active
    if (this.isActive) {
      this.lastActiveViewer = viewer;
    }

    return viewer;
  }

  get sectionMaterialLoaded(): any {
    if(this.sectionLoaded.type == SECTION_TYPES.LESSON_MATERIAL.code && this.sectionSelected) {
      return this.sectionSelected.sectionMaterial;
    }
    if(this.sectionLoaded.type == SECTION_TYPES.LESSON_MATERIAL.code && this.projectSelected) {
      return this.projectSelected.section.sectionMaterial;
    }
    return this.course.viewer.materialSelected;
  }

  get course(): Course {
    return this.getCourseFromStore({courseId: this.courseId , classId: this.classId });
  }

  get validatePresentationTaskUser() : boolean {
    return this.currentBoardUserId && this.userId !== this.currentBoardUserId && this.sectionLoaded.sectionId == this.currentBoardUser.sectionId;
  }

  get presentationCourseSelected(): number {
    return this.$store.state.CourseStore.presentationCourseSelected;
  }

  get isShow() : boolean{
    // return (this.isPresentationModeTeacher && this.presentationCourseSelected === this.courseId) || !this.isPresentationModeTeacher;
    return true;
  }

  @Watch('viewerLoad', { immediate: true, deep: true })
  setFooterType() {
    if(this.sectionSelected) { 
      this.$App.Store.changeFooterType(SECTION_TYPES[this.sectionSelected.type].viewerFooter);
    } else if (this.projectSelected) {
      this.$App.Store.changeFooterType(SECTION_TYPES[this.projectSelected.type].viewerFooter);
    } else {
      this.$App.Store.changeFooterType(FOOTER_TYPE.NONE);
    }
  }

  getSectionMaterial(info: Content) {
    if(info) {
      return new Section({
        sectionId: info.id,
        name: info.title,
        description: null,
        text: info.subtype,
        type: info.type,
        assetsInfo: [{
          url: info.url
        }]
      });
    }
    return null;
  }

  setComponent() {
    let selectInfo: IparamsComponentSelected = {courseId: this.courseId , classId: this.classId , 
    componentInfo: { name: COMPONENT_TYPE.LESSON_CREATOR.code , section: null , edition: false }};
    this.goToComponentSelected(selectInfo);
  }

  setProjectComponent() {
    let selectInfo: IparamsComponentSelected = {courseId: this.courseId , classId: this.classId , 
    componentInfo: { name: COMPONENT_TYPE.PROJECT_CREATOR.code , section: null , edition: false }};
    this.goToComponentSelected(selectInfo);
  }

  sectionRemoved(sectionId: number) {
    if(this.sectionLoaded.sectionId == sectionId) this.setComponent();
  }

  materialRemoved(materialId: number) {
    if(this.sectionMaterialLoaded?.relatedContentId == materialId) this.setComponent();
  }

  projectRemoved(projectId: number) {
    if(this.projectSelected && this.projectSelected.projectId == projectId) {
      this.setProjectComponent();
    }
  }

  notifyUserPosition() {
    const sectionId = this.sectionSelected?.sectionId;
    const classId = (this.sectionSelected || this.materialSelected)?.classId;
    const courseId = (this.sectionSelected || this.materialSelected)?.courseId;
    const homeworkId = null;
    this.$App.Store.updateUserPosition({classId, courseId, sectionId, homeworkId});
  }

  mounted() {
    this.$edEventBus.$on(COURSES_EVENTS.SECTION_REMOVED, this.sectionRemoved);
    this.$edEventBus.$on(COURSES_EVENTS.COURSE_MATERIAL_REMOVED, this.materialRemoved);
    this.$edEventBus.$on(COURSES_EVENTS.PROJECT_REMOVED, this.projectRemoved);
    this.notifyUserPosition();
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSES_EVENTS.SECTION_REMOVED, this.sectionRemoved);
    this.$edEventBus.$off(COURSES_EVENTS.COURSE_MATERIAL_REMOVED, this.materialRemoved);
    this.$edEventBus.$off(COURSES_EVENTS.PROJECT_REMOVED, this.projectRemoved);
  }

  deactivated() {
    this.isActive = false;
  }

  activated() {
    this.isActive = true;
  }

}